<template>
  <div class="w-full px-0 py-6 md:p-6">
    <div class="border rounded font-medium">
      <div class="p-4 header border-b">Bulk Export List</div>
    </div>
    <div class="border rounded mt-4 mb-10 p-4">
      <div
        v-for="(item, index) in bulkExports"
        :key="item.id"
        class="flex justify-between mb-2 pb-2"
        :class="{ 'border-b': index != bulkExports.length - 1 }"
      >
        <div class="self-center">
          <p class="font-medium">{{ getFilename(item) }}</p>
          <p v-if="item.status == 9" class="text-sm text-red mt-2">
            {{ item.description }}
          </p>
          <span class="block text-xs text-grey-darker mt-2">
            {{ formatDate(item.created_at) }}
          </span>
        </div>

        <div class="self-center">
          <span
            v-if="item.status == 1"
            class="rounded-full text-brand p-2 text-sm my-1 block"
            >Creating</span
          >
          <span
            v-if="item.status == 2"
            class="rounded-full text-orange p-2 text-sm my-1 block"
            >On Progress</span
          >
          <span
            v-if="item.status == 9"
            class="rounded-full text-red p-2 text-sm my-1 block"
            >Error</span
          >

          <div class="flex" v-if="item.status == 3">
            <button
              @click="download(item)"
              class="
                border border-brand
                bg-white
                p-2
                text-brand
                rounded
                font-medium
                text-sm
                hover:bg-brand hover:text-white
              "
            >
              <i class="fa fa-download"></i>
              Download
            </button>
            <button
              @click.prevent="deleteExport(item)"
              class="
                py-2
                px-3
                border border-red
                text-red
                rounded
                font-medium
                text-sm
                ml-2
                hover:bg-red hover:text-white
              "
            >
              <i class="fa fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <p
      class="
        mt-4
        p-2
        bg-orange-lightest
        w-full
        text-xs
        italic
        border-l-4 border-orange-light
      "
    >
      <span class="text-red font-semibold">*</span> Bulk exports expire after 7
      days.
    </p>

    <!-- delete confirmation modal -->
    <sweet-modal
      icon="warning"
      overlay-theme="dark"
      ref="confirm_delete_file_export"
    >
      <div class="flex flex-col">
        <span> Are you sure want to delete this file?</span>

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click.prevent="processDelete"
          >
            Yes
          </button>
          <button
            class="
              border
              bg-grey-lighter
              p-4
              w-32
              text-black
              border-grey
              rounded
              font-medium
            "
            @click="
              $refs.confirm_delete_file_export.close();
              selectedFile = null;
            "
          >
            No
          </button>
        </div>
      </div>
    </sweet-modal>

    <!-- delete processing modal -->
    <sweet-modal
      ref="processing_delete_file_export"
      overlay-theme="dark"
      hide-close-button
    >
      <div class="mt-4">
        <p class="text-6xl text-grey-dark">
          <i class="fa fa-spin fa-circle-notch"></i>
        </p>
        Please wait...
      </div>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  name: "BulkExport",
  props: ["bulkExports"],

  data() {
    return {
      selectedFile: null,
    };
  },

  methods: {
    getFilename(item) {
      if (!item.filename) {
        let name =
          moment(item.created_at).format("YYYY-MM-DD h:mm:ss") + ".zip";
        return name;
      }

      return item.filename;
    },
    download(item) {
      const url = `/api/vaults/${this.$route.params.vault_id}/bulk-exports/${item.id}/download`;
      window.open(url, "_blank");
    },
    deleteExport(item) {
      this.$refs.confirm_delete_file_export.open();
      this.selectedFile = item;
    },
    processDelete() {
      this.$refs.confirm_delete_file_export.close();
      this.$refs.processing_delete_file_export.open();
      axios
        .delete(
          `/api/vaults/${this.$route.params.vault_id}/bulk-exports/${this.selectedFile.id}`
        )
        .then((response) => {
          if (response && response.data) {
            const data = response.data;
            if (data.success) {
              this.$noty.success(data.message);
              this.$emit("exportFileDeleted");
            } else {
              this.$noty.error(data.message);
            }
          }
        })
        .catch((error) => {
          if (error && error.response) {
            this.$noty.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.selectedFile = null;
          this.$refs.processing_delete_file_export.close();
        });
    },
    formatDate(date) {
      return moment(date).format("h:mma D MMM");
    },
  },
};
</script>
